import React from 'react';
import Footer from './components/Footer';

import Home from './pages/Home';
import Experience from './pages/Experience';
import Projects from './pages/Projects';
import Skills from './pages/Skills'
import './App.css';

const App = () => {
  return (
    <div className="App">
      <Home />
      <Experience/>
      <Projects/>
      <Skills/>
      <Footer />
    </div>
  );
}

export default App;
